import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/express-add-ons-docs/express-add-ons-docs/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p><a parentName="p" {...{
        "href": "../overview.md"
      }}>{`@express-document-sdk`}</a>{` / EditorEvent`}</p>
    <h1 {...{
      "id": "enumeration-editorevent"
    }}>{`Enumeration: EditorEvent`}</h1>
    <p>{`This enum represents the supported editor events.`}</p>
    <h2 {...{
      "id": "enumeration-members"
    }}>{`Enumeration Members`}</h2>
    <h3 {...{
      "id": "selectionchange"
    }}>{`selectionChange`}</h3>
    <p>{`• `}<strong parentName="p">{`selectionChange`}</strong>{`: `}<inlineCode parentName="p">{`"selectionChange"`}</inlineCode></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      